module.exports = __webpack_public_path__ + "static/media/effect_08.47b3c905.png";